<div
  #qaElement
  class="quick-action-container"
  [attr.aria-expanded]="isExpanded()"
  [attr.aria-readonly]="data()?.readonly ?? false">
  <div class="quick-action-label" iuLoading role="button" [dataToWatch]="data" (click)="applyFunction(data())">
    <span>{{ data().label }}</span>
    @if (icon()) {
      <i aria-hidden="true" [class]="icon()"></i>
    }
  </div>
  @if (data().subActions?.length > 0) {
    <div class="quick-action-subactions">
      <div class="quick-action-subactions-wrapper" role="list">
        @for (sa of data().subActions; track $index) {
          <span
            class="quick-action-subactions-label"
            role="listitem"
            title="{{ sa.displayValue }}"
            (click)="applyFunction(sa)">
            {{ sa.displayValue }}
          </span>
        }
      </div>
    </div>
  }
</div>
